import { Translation } from '../types';

export default  {
  // App
  appTitle: "OK Money - Lebensplan-Simulator",
  
  // Navigation
  navigation: {
    home: "Startseite",
    lifePlan: "Lebensplan",
    riskSimulation: "Risikosimulation",
    contact: "Kontakt",
    openMenu: "Menü öffnen",
    lifePlanDescription: "Erstellen Sie einen Lebensplan, um Ihre Zukunft zu gestalten",
    riskSimulationDescription: "Führen Sie eine Risikosimulation durch, um Anlagerisiken zu bewerten",
  },

  // Home
  home: {
    hero: {
      title: "Realistische Lebensplanung durch Simulation",
      subtitle: "Optimieren Sie Ihren Lebensplan mit Simulationen, die Unsicherheiten berücksichtigen",
      download: "Herunterladen",
      docs: "Dokumentation"
    },
    features: {
      codeCompletion: {
        title: "Echtzeit-Simulation",
        description: "Simulieren Sie Marktschwankungen in Echtzeit und erhalten Sie optimale Finanzpläne"
      },
      codebase: {
        title: "KI-Analyse",
        description: "Analysieren Sie Ihr Anlageportfolio mit historischen Daten und KI, und erhalten Sie Verbesserungsvorschläge"
      },
      naturalLanguage: {
        title: "Investitionen, die Ihr Leben bereichern",
        description: "Vermehren Sie Ihr Vermögen durch Investitionen und sichern Sie gleichzeitig die für den Alltag benötigten Mittel"
      }
    },
  },

  // Unternehmen & Nutzungsbedingungen
  company: {
    title: "Unternehmensinformationen",
    basicInfo: "Grundinformationen",
    operatorName: "Betreibername",
    startDate: "Gründungsdatum",
    startDateValue: "28. April 2025",
    location: "Standort",
    locationValue: "Yokohama, Japan",
    contact: "Kontakt",
    contactForm: "Kontaktformular",
    businessDescription: "Geschäftsbeschreibung",
    businessDescriptionContent: "Wir bieten Finanzdienstleistungen an, um Ihr Leben ohne finanzielle Sorgen zu verbessern.",
    developerProfile: "Entwicklerprofil",
    developerProfileContent: "Wir sind ein Team von Entwicklern, die sich leidenschaftlich für die Erstellung von Finanzdienstleistungen einsetzen, um Ihr Leben ohne finanzielle Sorgen zu verbessern.",
    privacyPolicy: "Datenschutzerklärung",
    privacyPolicyLink: "Hier finden Sie die vollständige Datenschutzerklärung",
    termsOfService: "Nutzungsbedingungen",
    termsOfServiceContent: "Wir sind ein Team von Entwicklern, die sich leidenschaftlich für die Erstellung von Finanzdienstleistungen einsetzen, um Ihr Leben ohne finanzielle Sorgen zu verbessern.",
    contentEnd: "Bei Fragen kontaktieren Sie uns bitte."
  },
  terms: {
    title: "Nutzungsbedingungen",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzerklärung",
    article1: {
      title: "Artikel 1 (Anwendung)",
      content: "Diese Nutzungsbedingungen gelten für OKMoney (nachfolgend als 'Unternehmen' bezeichnet) und die von uns bereitgestellten Dienste (nachfolgend als 'Dienste' bezeichnet)."
    },
    article2: {
      title: "Artikel 2 (Registrierung)",
      content1: "1. Um die Dienste zu nutzen, müssen Sie den Nutzungsbedingungen zustimmen und sich über die von uns bestimmten Methoden registrieren.",
      content2: "2. Wir behalten uns das Recht vor, die Registrierung zu verweigern, wenn wir feststellen, dass die Bewerbung von einer Person stammt, die gegen die Nutzungsbedingungen verstoßen hat oder wenn wir die Registrierung als unangemessen erachten.",
      listItem1: "Bewerbungen von Personen, die gegen die Nutzungsbedingungen verstoßen haben",
      listItem2: "Andere Gründe, die wir als unangemessen erachten"
    },
    article3: {
      title: "Artikel 3 (Verbotene Handlungen)",
      content: "Sie dürfen die folgenden Handlungen nicht ausführen:",
      listItem1: "Handlungen, die Gesetze oder öffentliche Ordnung verletzen",
      listItem2: "Handlungen, die mit Straftaten verbunden sind",
      listItem3: "Handlungen, die die Betriebsfähigkeit unserer Dienste beeinträchtigen könnten",
      listItem4: "Handlungen, die anderen Nutzern das Leben schwer machen",
      listItem5: "Andere Handlungen, die wir als unangemessen betrachten"
    },
    article4: {
      title: "Artikel 4 (Einstellung oder Unterbrechung der Dienste)",
      content: "Wir behalten uns das Recht vor, die vollständige oder teilweise Bereitstellung der Dienste zu unterbrechen oder zu unterbrechen, ohne Sie vorher zu informieren, wenn eine der folgenden Ursachen vorliegt:",
      listItem1: "Wartung oder Aktualisierung unserer Computer-Systeme",
      listItem2: "Schwierigkeiten bei der Bereitstellung unserer Dienste aufgrund von Naturkatastrophen wie Erdbeben, Blitzschlag, Brand, Stromausfall oder Naturkatastrophen",
      listItem3: "Andere Gründe, die wir als schwierig betrachten"
    },
    article5: {
      title: "Artikel 5 (Haftungsausschluss)",
      content: "Wir haften für keine Transaktionen, Kontakte oder Streitigkeiten zwischen Ihnen und anderen Nutzern oder Dritten in Bezug auf die Dienste."
    },
    article6: {
      title: "Artikel 6 (Änderung der Dienste",
      content: "Wir behalten uns das Recht vor, die Inhalte ohne vorherige Mitteilung zu ändern oder die Bereitstellung der Dienste zu unterbrechen, und haften für Schäden, die Ihnen durch diese Maßnahmen entstehen."
    },
    article7: {
      title: "Artikel 7 (Änderung der Nutzungsbedingungen)",
      content: "Wir behalten uns das Recht vor, die Nutzungsbedingungen jederzeit zu ändern, wenn wir dies als notwendig erachten."
    },
    article8: {
      title: "Artikel 8 (Mitteilung oder Kontakt)",
      content: "Mitteilungen oder Kontakte zwischen Ihnen und uns erfolgen nach den von uns bestimmten Methoden."
    },
    article9: {
      title: "Artikel 9 (Verbot der Übertragung von Rechten und Pflichten)",
      content: "Sie dürfen keine Rechte oder Pflichten aus der Vertragsstellung oder den Nutzungsbedingungen an Dritte übertragen oder als Sicherheit zur Verfügung stellen."
    },
    article10: {
      title: "Artikel 10 (Rechtsgrundlagen und Gerichtsstand)",
      content1: "1. Für die Interpretation dieser Nutzungsbedingungen verwenden wir das Recht Japans als Rechtsgrundlage.",
      content2: "2. Wenn Streitigkeiten aus der Bereitstellung der Dienste entstehen, liegt die Zuständigkeit bei dem Gericht in unserer Hauptgeschäftsstelle."
    },
    privacy: {
      article1: {
        title: "1. Sammlung personenbezogener Daten",
        content: "Wir können in Bezug auf die Bereitstellung unserer Dienste personenbezogene Daten sammeln, wenn dies erforderlich ist:",
        listItem1: "Name",
        listItem2: "E-Mail-Adresse",
        listItem3: "Adresse",
        listItem4: "Telefonnummer",
        listItem5: "Andere Informationen, die für die Bereitstellung unserer Dienste erforderlich sind"
      },
      article2: {
        title: "2. Verwendungszweck personenbezogener Daten",
        content: "Die gesammelten personenbezogenen Daten werden wie folgt verwendet:",
        listItem1: "Bereitstellung und Betrieb der Dienste",
        listItem2: "Antwort auf Anfragen",
        listItem3: "Verbesserung und Entwicklung der Dienste",
        listItem4: "Mitteilung wichtiger Mitteilungen"
      },
      article3: {
        title: "3. Verwaltung personenbezogener Daten",
        content: "Wir führen angemessene Sicherheitsmaßnahmen durch, um die Offenlegung, Verlust oder Beschädigung personenbezogener Daten zu verhindern."
      },
      article4: {
        title: "4. Bereitstellung personenbezogener Daten an Dritte",
        content: "Wir stellen personenbezogene Daten an Dritte bereit, es sei denn, es liegen Ausnahmen vor:",
        listItem1: "Wenn Sie ausdrücklich zustimmen",
        listItem2: "Wenn dies aufgrund einer Vorschrift erforderlich ist",
        listItem3: "Wenn es für die Schutzung der Leben, Körper oder Eigentum einer Person erforderlich ist"
      },
      article5: {
        title: "5. Anfragen",
        content: "Wenden Sie sich bitte an die Kontaktformular, um Fragen zur Datenschutzerklärung zu stellen."
      },
      article6: {
        title: "6. Änderung der Datenschutzerklärung",
        content: "Wir können die Datenschutzerklärung jederzeit ändern, wenn dies erforderlich ist."
      }
    }
  },

  // Allgemein
  common: {
    years: "Jahre",
    perYear: "/Jahr",
    perMonth: "/Monat",
    age: "Alter",
    yes: "Ja",
    no: "Nein",
    none: "Keine",
    notEntered: "Nicht eingegeben",
    add: "Hinzufügen",
    delete: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    reset: "Zurücksetzen",
    month: "Monat",
    select: "Auswählen",
    clearSelection: "Auswahl löschen",
    dateTime: "Datum & Uhrzeit",
    actions: "Aktionen",
    currencies: {
      jpy: "Japanischer Yen",
      usd: "US-Dollar",
      eur: "Euro",
      gbp: "Britisches Pfund",
      aud: "Australischer Dollar",
      cad: "Kanadischer Dollar",
      chf: "Schweizer Franken",
      cny: "Chinesischer Yuan",
      hkd: "Hongkong-Dollar",
      sgd: "Singapur-Dollar"
    },
    currency: "Währung",
    currencyHelp: "Wählen Sie die Währung. Die Simulation wird in der ausgewählten Währung durchgeführt.",
    statistics: {
      title: "Statistiken",
      mean: "Durchschnitt",
      median: "Median",
      min: "Minimum",
      max: "Maximum",
      mode: "Modus",
      totalInvestment: "Gesamtinvestition",
      assetDistribution: "Vermögensverteilung",
      targetAchieveRate: "Zielerreichungsrate",
      probability: "Wahrscheinlichkeit",
      medianFinalAsset: "Median-Endvermögen",
      finalAsset: "Endvermögen",
    }
  },

  // Risikosimulation
  riskSimulation: {
    title: "Risikosimulation",
    simulationSettings: "Simulationseinstellungen",
    initialInvestment: "Anfangsinvestition",
    investmentAmount: "Investitionsbetrag",
    investmentPeriod: "Anlagezeitraum",
    annualReturnRate: "Jährliche Rendite",
    monthlyInvestment: "Monatliche Investition",
    volatility: "Volatilität",
    targetAmount: "Zielbetrag",
    runSimulation: "Simulation starten",
    running: "Läuft",
    simulationInstruction: "Bitte führen Sie zuerst die Simulation aus.",
    noSimulationRun: "Keine Simulation durchgeführt",
    simulationResults: "Simulationsergebnisse",
    currentResults: "Aktuelle Ergebnisse",
    savedResults: "Gespeicherte Ergebnisse",
    compare: "Vergleichen",
    resultTitle: "Risikosimulationsergebnisse",
    simulationConditions: "Simulationsbedingungen",
    saveSimulationResult: "Simulationsergebnis speichern",
    saveSimulationDescription: "Bitte geben Sie den Namen des Simulationsergebnisses ein.",
    simulationName: "Simulationsname",
    simulationNamePlaceholder: "Namen des Simulationsergebnisses eingeben",
    saveSimulation: "Simulation speichern",
    noSavedSimulations: "Keine gespeicherten Simulationen",
    noSavedSimulationsDescription: "Keine gespeicherten Simulationen gefunden. Bitte führen Sie zuerst eine Simulation durch.",
    createNewSimulation: "Neue Simulation erstellen",
    selectSimulationsToCompare: "Simulationen zum Vergleichen auswählen",
    noSelectedSimulations: "Keine ausgewählten Simulationen",
    selectTwoOrMoreSimulations: "Bitte wählen Sie zwei oder mehr Simulationen zum Vergleichen aus.",
    comparisonResults: "Vergleichsergebnisse",
    finalAssetComparison: "Endvermögensvergleich",
    finalAssetComparisonDescription: "Vergleich des Endvermögens der Simulationen",
    successRateComparison: "Erfolgsratenvergleich",
    successRateComparisonDescription: "Vergleich der Erfolgsraten der Simulationen",
    simulationParameters: "Simulationsparameter",
    simulationParametersDescription: "Vergleich der Simulationsparameter der Simulationen",
    period: "Zeitraum",
    successRate: "Erfolgsrate",
    backToSimulation: "Zurück zur Simulation",
  },

  // Lebensplan
  lifePlan: {
    title: "Lebensplan erstellen",
    resultTitle: "Lebensplan-Simulationsergebnisse",
    steps: {
      basicInfo: "Grundinformationen",
      incomeExpense: "Einnahmen & Ausgaben",
      assetsLiabilities: "Vermögen & Verbindlichkeiten",
      lifeGoals: "Lebensziele",
      simulationSettings: "Simulationseinstellungen",
      confirmation: "Bestätigung",
    },
    navigation: {
      prev: "Zurück",
      next: "Weiter",
      startSimulation: "Simulation starten",
      confirmStart: "Möchten Sie die Simulation starten?",
      confirmStartTitle: "Simulationsstart Bestätigen",
      cancel: "Abbrechen",
    },
    basicInfo: {
      title: "Grundinformationen",
      name: "Name",
      namePlaceholder: "Geben Sie Ihren Namen ein",
      age: "Alter",
      gender: {
        title: "Geschlecht",
        male: "Männlich",
        female: "Weiblich",
        other: "Andere",
      },
      familyStructure: {
        title: "Familienstruktur",
        hasSpouse: "Hat Ehepartner",
        spouseAge: "Alter des Ehepartners",
        children: "Kinder",
        help: "Geben Sie Ihre Familienstruktur ein",
        childrenHelp: "Fügen Sie Kinder und ihre Altersangaben hinzu",
        addChild: "Kind hinzufügen",
        removeChild: "Kind entfernen",
        noChildren: "Keine Kinder",
      },
      spouse: "Ehepartner",
      children: "Kinder"
    },
    incomeExpense: {
      title: "Einnahmen & Ausgaben",
      income: {
        title: "Einnahmen",
        annualIncome: "Jahreseinkommen",
        salaryIncreaseRate: "Gehaltserhöhungsrate",
        annualBonus: "Jahresbonus",
      },
      expense: {
        title: "Ausgaben",
        help: "Geben Sie Ihre monatlichen Ausgaben ein",
        housingCost: "Wohnkosten",
        housingCostHelp: "Geben Sie Ihre monatlichen Wohnkosten einschließlich Miete oder Hypothek ein",
        utilities: "Nebenkosten",
        food: "Lebensmittel",
        communication: "Kommunikation",
        transportation: "Transport",
        entertainment: "Unterhaltung",
        investment: "Investition",
        stocks: "Aktieninvestition",
        bonds: "Anleiheinvestition",
        mutualFunds: "Investmentfonds",
        insurance: "Versicherungsprämie",
        other: "Sonstiges",
      },
      annualIncome: "Jahreseinkommen",
      salaryIncreaseRate: "Gehaltserhöhungsrate",
      annualBonus: "Jahresbonus",
      housingCost: "Wohnkosten",
      utilities: "Nebenkosten",
      food: "Lebensmittel",
      communication: "Kommunikation",
      transportation: "Transport",
      entertainment: "Unterhaltung",
      other: "Sonstiges"
    },
    assetsLiabilities: {
      title: "Vermögen und Verbindlichkeiten",
      assets: {
        title: "Vermögen",
        savings: "Ersparnisse",
        stocks: "Aktien",
        bonds: "Anleihen",
        mutualFunds: "Investmentfonds",
        insurance: "Versicherung",
        other: "Sonstiges",
        amount: "Betrag (10.000 €)",
        return: "Erwartete Rendite (%)",
        volatility: "Volatilität (%)",
        investmentAssets: "Anlagevermögen",
      },
      liabilities: {
        title: "Verbindlichkeiten",
        housingLoan: "Immobilienkredit",
        carLoan: "Autokredit",
        otherLoans: "Sonstige Kredite",
        addLoan: "Kredit hinzufügen",
        removeLoan: "Kredit entfernen",
        name: "Kreditname",
        amount: "Kreditbetrag (10.000 €)",
        period: "Laufzeit (Jahre)",
        interestRate: "Zinssatz (%)",
        noLoans: "Keine Kredite",
      },
      savings: "Ersparnisse",
      stocks: "Aktien",
      bonds: "Anleihen",
      mutualFunds: "Investmentfonds",
      insurance: "Versicherung",
      otherInvestments: "Sonstige Anlagen",
      housingLoanBalance: "Immobilienkredit-Saldo",
      housingLoanPeriod: "Kreditlaufzeit",
      housingLoanInterest: "Zinssatz",
      noLoans: "Keine Kredite",
      otherLoans: "Sonstige Kredite"
    },
    lifeGoals: {
      title: "Lebensziele",
      housingPurchase: "Immobilienerwerb",
      educationFunds: "Bildungsfonds",
      child: "Kind",
      otherGoals: "Andere Ziele",
      retirementAge: "Renteneintrittsalter",
      retirementMonthlyExpense: "Monatliche Ausgaben nach Renteneintritt",
      notPlanned: "Nicht geplant",
      housing: {
        title: "Immobilienziele",
        planned: "Geplante Immobilie",
        year: "Geplantes Jahr",
        amount: "Geplanter Betrag",
        purchaseYear: "Kaufjahr",
        purchaseAmount: "Kaufbetrag",
      },
      education: {
        title: "Bildungsfonds-Plan",
        subtitle: "Bildungsfonds-Planung",
        add: "Bildungsfonds hinzufügen",
        remove: "Bildungsfonds entfernen",
        name: "Bildungsfonds-Name",
        namePlaceholder: "Bildungsfonds-Namen eingeben",
        childAge: "Alter des Kindes",
        age: "Erforderliches Alter",
        amount: "Erforderlicher Betrag",
        requiredAmount: "Erforderlicher Betrag",
        noData: "Keine Bildungsfonds hinzugefügt",
      },
      other: {
        title: "Andere Ziele",
        subtitle: "Andere Lebensziele",
        add: "Ziel hinzufügen",
        remove: "Ziel entfernen",
        name: "Zielname",
        year: "Zieljahr",
        amount: "Erforderlicher Betrag",
        noData: "Keine Ziele hinzugefügt",
        namePlaceholder: "Geben Sie den Namen des anderen Ziels ein",
        plannedAge: "Geplantes Alter",
        requiredAmount: "Erforderlicher Betrag"
      },
      retirement: {
        title: "Rentenplanung",
        age: "Geplantes Renteneintrittsalter",
        monthlyExpense: "Monatliche Ausgaben nach Renteneintritt",
      },
    },
    simulationSettings: {
      title: "Simulationseinstellungen",
      inflationRate: "Inflationsrate (%)",
      investmentReturn: "Anlagerendite (%)",
      simulationPeriod: "Simulationszeitraum (Jahre)",
      currency: "Währung",
      currencyHelp: "Wählen Sie die Währung. Die Simulation wird in der ausgewählten Währung durchgeführt.",
      inflationRateHelp: "Simulation unter Berücksichtigung der zukünftigen Inflationsrate."
    },
    runningSimulation: "Simulation läuft",
    result: {
      title: "Lebensplan-Simulationsergebnisse",
      settings: "Lebensplaneinstellungen",
      planSettings: "Planeinstellungen",
      actions: {
        print: "Drucken",
        downloadCSV: "CSV herunterladen",
        modifyConditions: "Bedingungen ändern",
        backToInput: "Zurück zur Eingabe",
      },
      tabs: {
        charts: "Diagramme",
        details: "Details",
        analysis: "Analyse & Empfehlungen",
      },
      charts: {
        assetIncomeExpense: "Vermögens- & Einnahmen/Ausgaben-Trends",
        agePoint: "Im Alter von {age}",
        spouse: "Ehepartner: {age} Jahre",
        children: "Kinder",
        age: "{age} Jahre",
        assets: "Vermögen",
        liabilities: "Verbindlichkeiten",
        netWorth: "Nettovermögen",
        amount: "Betrag",
        noData: "Keine Daten verfügbar",
        assetTrend: "Vermögenstrends",
        incomeExpenseTrend: "Einnahmen/Ausgaben-Trends",
        income: "Einnahmen",
        expense: "Ausgaben",
        savings: "Ersparnisse",
      },
      details: {
        yearlyData: "Jahresdaten-Details",
      },
      analysis: {
        risk: "Risikoanalyse",
        recommendations: "Verbesserungsempfehlungen",
      },
      table: {
        search: "Suchen...",
        age: "Alter",
        familyAge: "Familienalter",
        income: "Einnahmen",
        expense: "Ausgaben",
        savings: "Ersparnisse",
        assets: "Vermögen",
        lifeEvents: "Lebensereignisse",
        ageValue: "{age} Jahre",
        spouse: "Ehepartner: {age} Jahre",
        children: "Kinder",
        amount: "10.000",
        noData: "Keine Daten verfügbar",
      },
      timeline: {
        age: "Alter",
        event: "Ereignis",
        retirement: "Rente",
        ageValue: "{age} Jahre",
        agePoint: "Im Alter von {age}",
        spouse: "Ehepartner: {age} Jahre",
        children: "Kinder",
        neededAmount: "Benötigt: {amount}",
        assets: "Vermögen: {amount}",
        education: "{childName}s {fundName}",
        child: "Kind",
        educationFund: "Bildungsfonds"
      },
      summary: {
        title: "Zusammenfassung",
        monthlyIncome: "Monatliche Einnahmen",
        monthlyExpense: "Monatliche Ausgaben",
        monthlyInvestment: "Monatliche Investition",
        monthlySavings: "Monatliche Ersparnisse",
        totalAssets: "Gesamtvermögen",
        totalLiabilities: "Gesamtverbindlichkeiten",
        netWorth: "Nettovermögen",
        finalAssets: "Endvermögen",
        peakAssets: "Vermögen im Spitzenzeitraum",
        retirementAssets: "Vermögen bei Renteneintritt",
        savingsRate: "Ersparnisrate",
        savingsRateDesc: "Anteil der Ersparnisse am Einkommen",
        retirementBalance: "Einkommens- und Ausgabenüberschuss",
        balance: "Einkommens- und Ausgabenüberschuss",
        riskAssessment: "Risikoanalyse",
        riskLow: "Niedriges Risiko",
        riskMedium: "Mittleres Risiko",
        riskHigh: "Hoches Risiko",
        negativeAssets: "Es gibt eine Periode, in der Ihr Vermögen negativ wird.",
        positiveAssets: "Vermögen wird erwartet, um ständig positiv zu bleiben.",
        needImprovement: "Einkommens- und Ausgabenverbesserung erforderlich",
        unit: "10.000",
        atAge: "Im Alter von {age}",
      },
      chart: {
        title: "Vermögensverlauf",
        noData: "Daten eingeben",
        assets: "Vermögen",
        income: "Einnahmen",
        expense: "Ausgaben",
      },
    },
    confirmation: {
      title: "Bestätigung"
    },
    validation: {
      error: "Es gibt einen Fehler in der Eingabe."
    },
  },
  login: "Anmelden",
  register: "Registrieren",
  loginDescription: "Noch kein Konto? Bitte registrieren Sie sich.",
  registerDescription: "Erstellen Sie ein Konto, um mit Ihrer Lebensplan-Simulation zu beginnen.",
  email: "E-Mail",
  password: "Passwort",
  passwordRequirements: "Das Passwort muss mindestens 8 Zeichen lang sein und sowohl Buchstaben als auch Zahlen enthalten.",
  loggingIn: "Anmeldung läuft...",
  registering: "Registrierung läuft...",
  loginFailed: "Anmeldung fehlgeschlagen.",
  registrationSuccess: "Registrierung abgeschlossen.",
  registrationFailed: "Registrierung fehlgeschlagen.",
  myPage: "Mein Konto",
  logout: "Abmelden",
  userProfile: "Benutzerprofil",
  userProfileDescription: "Verwalten Sie Ihre Profilinformationen",
  savedSimulations: "Gespeicherte Simulationen",
  savedSimulationsDescription: "Liste Ihrer gespeicherten Simulationsergebnisse",
  settings: "Einstellungen",
  accountSettings: "Kontoeinstellungen",
  accountSettingsDescription: "Verwalten Sie Ihre Kontoeinstellungen",
  changePassword: "Passwort ändern",
  changePasswordDescription: "Ändern Sie Ihr Passwort",
} as Translation; 